module.exports = __webpack_public_path__ + "static/media/bunzl.0430a7eb.png";